import { render, staticRenderFns } from "./headline.vue?vue&type=template&id=58a6f443&scoped=true&"
import script from "./headline.vue?vue&type=script&lang=ts&"
export * from "./headline.vue?vue&type=script&lang=ts&"
import style0 from "./headline.vue?vue&type=style&index=0&id=58a6f443&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a6f443",
  null
  
)

export default component.exports